import { instances } from '@/services/http';
import { useQuery } from '@tanstack/vue-query';
import type { UserDashboardRelationsGetHelperRelationsResponseType } from '@magma-app/magma-types/user-dashboard/relation';

/**
 * Relations as a query rather than through the store, so the sidebar can show its action dot on
 * every page and not only once `RelationsLayout` has mounted.
 */
export const useRelations = (disabled?: boolean) => {
  return useQuery({
    queryKey: ['relations', 'helper'] as const,
    queryFn: async () => {
      const response = await instances.userDashboard.get('/relations/helper');
      return response.data as UserDashboardRelationsGetHelperRelationsResponseType;
    },
    retry: 1,
    staleTime: Infinity,
    enabled: disabled !== true,
  });
};
